/* eslint eqeqeq: 0 */
import React, { Component } from "react";
import { Translation, withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import { toast } from "react-toastify";
import { GroupListQuery } from "../../../constants/apiParams";
import apiCall, { METHOD } from "../../../constants/baseUrl";
import { getUserID } from "../../../util/utils";
import LoadingPage from "../../CommanComponents/LoadingPage";

class SearchGeneralGroup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      search: "",
      generalGroupList: [],
      isLoading: false
    };
    this.searchRef = React.createRef();
  }
  changeEventSearch = e => {
    const searchValue = e.target.value;
    this.setState(
      {
        search: searchValue,
        generalGroupList: []
      },
      () => {
        this.props.searchArray([]);
      }
    );
  };

  handleLoader = status => {
    this.setState(() => {
      return {
        isLoading: status
      };
    });
  };

  handleSearchResponse = data => {
    this.setState(
      () => {
        return {
          generalGroupList: data.group_list,
          isLoading: false
        };
      },
      () => {
        this.props.searchArray(data.group_list);
        if (this.state.generalGroupList.length == 0) {
          toast.info(
            this.props.t("GeneralMessages.searchErrorMessage") +
              "'" +
              this.state.search +
              "'"
          );
        }
      }
    );
  };
  loader = (<LoadingPage key={0}/>);
  clearSearch = () => {
    this.searchRef.current.value = "";

    this.setState(
      () => {
        return {
          ...this.state,
          search: "",
          generalGroupList: []
        };
      },
      () => {
        this.props.searchArray([]);
      }
    );
  };

  searchApi = () => {
    const { search } = this.state;

    apiCall(
      METHOD.QUERY,
      GroupListQuery(getUserID(),0, 100, 0, search, 0),
      (data) => this.handleSearchResponse(data),
      (isLoading) => this.handleLoader(isLoading),
      (data) => {
        toast.error(this.props.t(data.message));
      }
    );
  };

  render() {
    const { search } = this.state;
    return (
      <Translation ns="translation">
        {(t, { i18n }) => {
          return (
            <div className="clearfix mt-2 mb-2">
              <div className="input-group mt-3">
                <input
                  type="text"
                  placeholder={t("MailList.search")}
                  className="form-control"
                  ref={this.searchRef}
                  onChange={this.changeEventSearch}
                  onKeyPress={e =>
                    e.keyCode == 13 || (e.which == 13 && this.searchApi())
                  }
                />
                <div className="input-group-append ">
                  <span className="input-group-text bg-white input-group-append ">
                    <i
                      className="zmdi zmdi-search zmdi-hc-fw font-22 pointer"
                      onClick={this.searchApi}
                    ></i>
                    {search.length != 0 && (
                      <i
                        className="zmdi zmdi-close zmdi-hc-fw font-22 pointer"
                        onClick={this.clearSearch}
                      ></i>
                    )}
                  </span>
                </div>
              </div>
            </div>
          );
        }}
      </Translation>
    );
  }
}
export default withRouter(withTranslation()(SearchGeneralGroup));
